import { render, staticRenderFns } from "./ApiTree.vue?vue&type=template&id=0bb17623"
import script from "./ApiTree.vue?vue&type=script&lang=js"
export * from "./ApiTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports